import React from 'react';
import LoginForm from '../components/LoginForm';
import { Navigate } from "react-router";
import useAuth from "system/APIAuth";
import { wasSessionExpired } from 'system/InfegyUser';
import { useTranslation } from "react-i18next";

import { useLocation } from "react-router-dom";
import { Fade, Stack, Typography } from "@mui/material";
import { Box, useTheme } from '@mui/system';
import DynamicLoginPageBG from 'components/design/DynamicLoginPageBG';

export interface LoginPageProps {
  message?: string;
  onLogin?: () => void;
}

export default function LoginPage(props: LoginPageProps) {
  const auth = useAuth();
  const location = useLocation();
  const theme = useTheme();
  const { i18n } = useTranslation();

  let redirect = location?.state?.from?.pathname;
  if (!redirect) {
    redirect = "/dashboard";
  } else {
    if (location?.state?.from?.search && location?.state?.from?.search !== "?") {
      redirect += location?.state?.from?.search;
    }
    if (location?.state?.from?.hash && location?.state?.from?.hash !== "#") {
      redirect += location?.state?.from?.hash;
    }
  }

  if (auth?.user)
    return <Navigate to={redirect} replace={true} />;

  // message to display - either props passesd in, or we use a session expired message if auth has logged an expired session was attempted to be used
  const message = props.message || (wasSessionExpired() ? i18n.t("login.session-expired") : '');
  
  return (
    <Stack
      direction="row"
      spacing={0}
      sx={{
        justifyContent: "center",
        height: "100vh"
      }}>
        <Fade in timeout={1000}>
          <Box
            sx={{
              padding: 8,
              paddingTop: 6,
              width: "100%",
              maxWidth: 500
            }}>

            <img src="/img/Infegy_Logo_FullColor.svg" alt="Infegy logo" style={{ marginBottom: "3em", maxWidth: "90%" }} />

            <LoginForm message={message} onLogin={props.onLogin} />

            <Typography variant="h5" sx={{
              mt: 4
            }}>{i18n.t("login.tagline")}</Typography>
            <Typography sx={{
              mt: 2
            }}>{i18n.t("login.app-description")}<br/><a href="https://www.infegy.com/platform/infegy-starscape" target="_blank">{i18n.t("login.learn-more")}</a></Typography>
            <Typography sx={{
              mt: 2
            }}></Typography>
            <Typography sx={{
              mt: 2
            }}>{i18n.t("login.no-access")} <a href="https://www.infegy.com/resources/demo" target="_blank">{i18n.t("login.here")}</a>.</Typography>
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color: "GrayText"
              }}>Copyright ©{new Date().getFullYear()} Infegy, Inc. {i18n.t("copyright-rights")}</Typography>
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color: "GrayText"
              }}><a href="https://www.infegy.com/privacy" target="_blank">{i18n.t("login.privacy-policy")}</a> - <a href="https://www.infegy.com/terms-conditions" target="_blank">{i18n.t("login.terms-conditions")}</a></Typography>

          </Box>
        </Fade>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            minHeight: "100vh",
            padding: 0,
            display: { xs: 'none', md: 'block' }
          }}>
          {/* Keeping here in case we want to revert to the original background image */}
          {/* <img style={{ width: "100%", height: "100%", minHeight: "100vh", objectFit: "cover" }} alt=""
            src={theme.palette.mode === 'dark' ?
              "/img/login_splash.webp" :
              "/img/login_splash.webp"} /> */}
          <DynamicLoginPageBG />
        </Box>
      </Stack >
  );
}
